import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { commentCloseCommentDeleteModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { CommentDeleteForm } from './components'
// styles
import { styles } from './styles'

type CommentDeleteCardProps = {}

export const CommentDeleteCard: FC<CommentDeleteCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const commentDeleteError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile
          onCloseClick={() => dispatch(commentCloseCommentDeleteModal())}
        />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Delete Comment" icon={icons.Trash} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to delete your comment?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <CommentDeleteForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={commentDeleteError} />
        </div>
      </div>
    </div>
  )
}

CommentDeleteCard.propTypes = {}
